import { PERSONAL_WORKSPACE_ID } from './api/workspaceContext';

export const HOME_WORKSPACE_NAME_KEY = 'fokus:homeWorkspaceName';

export function personLabelFromEmail(email) {
  const local = String(email || '').trim().split('@')[0];
  if (!local) return '';
  const token = (local.split(/[._+\-]/)[0] || local).replace(/\d+$/g, '') || local;
  return token.charAt(0).toUpperCase() + token.slice(1);
}

export function defaultHomeWorkspaceName(user) {
  const label = personLabelFromEmail(user?.email);
  if (!label) return 'My brain';
  return `${label}'s brain`;
}

function readStoredHomeName() {
  try {
    const raw = window.localStorage?.getItem?.(HOME_WORKSPACE_NAME_KEY);
    const name = (raw || '').trim();
    return name || '';
  } catch {
    return '';
  }
}

export function storeHomeWorkspaceName(name) {
  try {
    const trimmed = (name || '').trim();
    if (!trimmed) window.localStorage?.removeItem?.(HOME_WORKSPACE_NAME_KEY);
    else window.localStorage?.setItem?.(HOME_WORKSPACE_NAME_KEY, trimmed);
  } catch {
    /* ignore quota / private mode */
  }
}

export function isGenericHomeName(name) {
  const n = String(name || '').trim().toLowerCase();
  return !n || n === 'personal';
}

export function displayWorkspaceName(ws, user) {
  if (!ws) return defaultHomeWorkspaceName(user);
  if (ws.id === PERSONAL_WORKSPACE_ID && isGenericHomeName(ws.name)) {
    return readStoredHomeName() || defaultHomeWorkspaceName(user);
  }
  return (ws.name || '').trim() || defaultHomeWorkspaceName(user);
}

export function decorateWorkspaces(list, user) {
  return (list || []).map((ws) => ({
    ...ws,
    name: displayWorkspaceName(ws, user),
  }));
}
